import type { ChainId, StoreId } from "@KassaroAB/shared/types/ids";

export type CatalogScope =
  | { type: "store"; id: StoreId }
  | { type: "chain"; id: ChainId };

export const storeScope = (id: StoreId): CatalogScope => ({
  type: "store",
  id,
});

export const chainScope = (id: ChainId): CatalogScope => ({
  type: "chain",
  id,
});

export const catalogParentPath = (scope: CatalogScope) =>
  `${scope.type === "store" ? "stores" : "chains"}/${scope.id}`;

export const catalogCollectionPath = (
  scope: CatalogScope,
  collection: string,
) => `${catalogParentPath(scope)}/${collection}`;

export const catalogPagePath = (
  scope: CatalogScope,
  collection: string,
  itemId?: string,
) => {
  const path = `/${catalogParentPath(scope)}/catalog/${collection}`;
  return itemId ? `${path}/${itemId}` : path;
};

export const catalogQueryKey = (
  scope: CatalogScope | null,
  collection: string,
) =>
  scope
    ? ([
        scope.type === "chain" ? "chains" : "stores",
        scope.id,
        collection,
      ] as const)
    : ([collection] as const);

export const productStoreCacheId = (scope: CatalogScope): string =>
  scope.type === "store" ? scope.id : `chain-${scope.id}`;
